// oxlint-disable-next-line import-extensions/file-extension-required
import { fullCapabilitiesSupportedBrowsers } from './fullCapabilitiesSupportedBrowsers';

export const showBrowserRuntimeWarning = (): boolean =>
	!fullCapabilitiesSupportedBrowsers.test(navigator.userAgent);
